import getStore from '../data/store/store';
import {
    getIsAutomaticReplyEnabled,
    getPeriodicReplyEnabled,
    getBlockCalendarEnabled,
    getDeclineNewInvitationsEnabled,
    getSendRepliesToContactsOnlyEnabled,
    getSendRepliesOutsideOrgEnabled,
    getBlockCalendarTitle,
    getStartDate,
    getEndDate,
    getDeclineExistingCalendarEventsEnabled,
} from '../selectors/getStoreProperties';

/**
 * Utility function to check if automatic replies option is dirty
 * @returns true if dirty else false
 */
export default function isAutomaticRepliesOptionDirty() {
    let optionsState = getStore().currentState;
    let initialState = getStore().initialState;

    const intialIsAutomaticReplyEnabled = initialState.isAutomaticReplyEnabled;
    const initialPeriodicReplyEnabled = initialState.periodicReplyEnabled;
    const initialBlockCalendarEnabled = initialState.blockCalendarEnabled;
    const initialBlockCalendarTitle = initialState.blockCalendarTitle;
    const initialDeclineNewInvitationsEnabled = initialState.declineNewInvitationsEnabled;
    const initialDeclineExistingInvitationsEnabled = false;
    const initialSendRepliesToContactsOnlyEnabled = initialState.sendRepliesToContactsOnlyEnabled;
    const initialSendRepliesOutsideOrgEnabled = initialState.sendRepliesOutsideOrgEnabled;
    const initialStartDate = initialState.startDate;
    const initialStartDateStr = initialStartDate ? initialStartDate.toString() : null;
    const initialEndDate = initialState.endDate;
    const initialEndDateStr = initialEndDate ? initialEndDate.toString() : null;

    const currentIsAutomaticReplyEnabled = getIsAutomaticReplyEnabled();
    const currentPeriodicReplyEnabled = getPeriodicReplyEnabled();
    const currentBlockCalendarEnabled = getBlockCalendarEnabled();
    const currentBlockCalendarTitle = getBlockCalendarTitle();
    const currentDeclineNewInvitationsEnabled = getDeclineNewInvitationsEnabled();
    const currentDeclineExistingInvitationsEnabled = getDeclineExistingCalendarEventsEnabled();
    const currentSendRepliesOnlyToContactsEnabled = getSendRepliesToContactsOnlyEnabled();
    const currentSendRepliesOutsideOrgEnabled = getSendRepliesOutsideOrgEnabled();
    const currentStartDate = getStartDate();
    const currentStartDateStr = currentStartDate ? currentStartDate.toString() : null;
    const currentEndDate = getEndDate();
    const currentEndDateStr = currentEndDate ? currentEndDate.toString() : null;

    const isDirty =
        optionsState.editorViewStateMessage.isDirty ||
        optionsState.editorViewStateDeclineMeeting.isDirty ||
        optionsState.editorViewStateOutsideOrg.isDirty ||
        currentPeriodicReplyEnabled !== initialPeriodicReplyEnabled ||
        currentIsAutomaticReplyEnabled !== intialIsAutomaticReplyEnabled ||
        currentBlockCalendarEnabled !== initialBlockCalendarEnabled ||
        currentDeclineNewInvitationsEnabled !== initialDeclineNewInvitationsEnabled ||
        currentSendRepliesOnlyToContactsEnabled !== initialSendRepliesToContactsOnlyEnabled ||
        currentSendRepliesOutsideOrgEnabled !== initialSendRepliesOutsideOrgEnabled ||
        currentDeclineExistingInvitationsEnabled !== initialDeclineExistingInvitationsEnabled ||
        currentBlockCalendarTitle !== initialBlockCalendarTitle ||
        currentStartDateStr !== initialStartDateStr ||
        currentEndDateStr !== initialEndDateStr;
    return isDirty;
}
